<!-- Panel Template -->
<ng-template #panel>
  <div
    class="mt-0.5 w-full transform overflow-hidden rounded-b-xl bg-white shadow-2xl outline-1 outline-black/5 transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in data-closed:sm:translate-y-0 data-closed:sm:scale-95"
    role="listbox"
    [id]="id">
    @if(!searchTerm && hasDefaultStateTpl) {
    <ng-container [ngTemplateOutlet]="defaultTpl"></ng-container>
    } @else if(searchTerm && !flattenedOptions.length && hasNoResultsStateTpl) {
    <ng-container [ngTemplateOutlet]="noResultsTpl"></ng-container>
    } @else {
    <div class="max-h-75 overflow-auto">
      <ng-content></ng-content>
    </div>
    }
  </div>
</ng-template>

<!-- Default Template -->
<ng-template #defaultTpl>
  <ng-content select="[app-autocomplete-state='default']"></ng-content>
</ng-template>

<!-- No Results Template -->
<ng-template #noResultsTpl>
  <ng-content select="[app-autocomplete-state='no-results']"></ng-content>
</ng-template>
